import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { initializePostHog } from "./utils/posthog";
import "@fontsource/geist-sans";  // 400 by default
import "@fontsource/geist-sans/500.css"; // optional specific weights

initializePostHog();

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="274641188872-u0am9fdf4kb4r6indvu06ehifoj8mfm7.apps.googleusercontent.com">
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
